'use strict';

angular.module('paizacloudApp')
  .directive('fileTreeView', function($http, $cookies, $uibModal, $timeout, $filter, PCModalFileUploadService) {
    return {
      // templateUrl: 'app/fileTree.directive/fileTree.directive.html',
      template: require('./fileTree.directive.html').default,
      restrict: 'EA',
      scope: {
        container: '=',
        controller: '=',
        ngModel: '=',
        windowModels: '=',
        onSelectNode: '&',
      },
      require: '^?containerwm',
      link: {
        pre: function(scope, element, attrs, wmController:any) {
          scope.ngModel.iconText = '📂';
          scope.node = scope.ngModel.node;
          scope.showHidden = false;

          /* open the node by default */
          if(scope.node.opened === undefined){
            scope.node.opened = true;
          }

          const selectFileItr = (node, filename) => {
            if(filename === node.id){
              node.scope.select();
            }else if(node.children && filename.startsWith(node.id) && (node.id === '/' || filename[node.id.length] === '/')){
              function goChildren(){
                node.children.forEach((childNode) => {
                  selectFileItr(childNode, filename);
                });
              }
              if(node.children instanceof Array){
                goChildren();
              }else{
                node.scope.open(() => {
                  let count = 0;
                  let num = node.children.length;
                  $timeout(() => {
                    goChildren();
                  }, 0);
                  /*
                  const off = node.scope.$on('link-end', (ev) => {
                    console.log('link-end', ev);
                    count += 1;
                    if(count === num){
                      console.log('link-end for all');
                      off();
                      goChildren();
                    }
                  });
                  */
                });
              }
            }
          };

          scope.controller.selectFile = (filename) => {
            selectFileItr(scope.node, filename);
          };

          $timeout(() => {
            scope.$emit('title', scope.ngModel.node.text);
          });

          let socket;
          function createNode(obj){
            const node = obj;
            node.icon = node.isDirectory ? 'jstree-folder' : 'jstree-file';
            node.state = {
              opened: false,
              disabled: false,
              selected: false,
            };
            node.children = node.isDirectory;
            return node;
          }

          scope.$watch('container.socket', (post, pre) => {
            socket = post;
            if(!post){
              return;
            }

            socket.on(`watch:${scope.$id}:updated`, (data) => {
              console.log(`watch:${scope.$id}:updated`, data);
              let obj = data;

              let q = [scope.node];
              while(q.length > 0){
                let node = q.shift();
                if(node.id === obj.parent){
                  if(obj.event === 'create' && (node.children instanceof Array)){
                    const newNode = createNode(obj.node);
                    node.children.push(newNode);
                    node.children.sort((a, b) => a.id.localeCompare(b.id));
                    if(toBeOpenedDirs[obj.id]){
                      obj.node.opened = true;
                      delete toBeOpenedDirs[node.id];
                    }
                  }
                }
                if(obj.event === 'delete'){
                  if(node.children instanceof Array){
                    node.children = node.children.filter((child) => child.id !== obj.id);
                  }
                }
                if(node.children instanceof Array){
                  q.push(...node.children);
                }
              }
            });

            if(scope.ngModel.node.scope){
              scope.ngModel.node.scope.close();
              scope.ngModel.node.scope.open();
            }
          });

          function getSelectedDirectory(){
            let node = scope.node;
            let nodes = scope.controller.getSelected();
            if(nodes && nodes.length > 0){
              node = nodes[0];
            }

            if(!node.children){
              node = node.parent;
            }
            return node.id;
          }
          scope.getSelectedDirectory = getSelectedDirectory;

          let toBeOpenedDirs = {};

          scope.mkdir = () => {
            let dir = 'newdir';
            window.swal({
              title: $filter('translate')('NEW_DIRECTORY'),
              text: $filter('translate')('DIRECTORY') + ':',
              input: 'text',
              inputValue: dir,
            })
              .then((newdir) => {
                if(newdir){
                  let newpath = getSelectedDirectory() + '/' + newdir;
                  toBeOpenedDirs[newpath] = true;
                  socket.emit('mkdir', newpath, /* 0o777*/ 511, (error) => {
                    if(error) {
                      window.swal('Error', error.message, 'error');
                    }
                  });
                }
              });
            $timeout(() => { $('.swal2-input').select(); });
          };

          scope.touch = function(){
            let file = 'newfile.txt';
            window.swal({
              title: 'Create file',
              text: 'File:',
              input: 'text',
              inputValue: file,
            })
              .then((newfile) => {
                if(newfile){
                  let newpath = getSelectedDirectory() + '/' + newfile;
                  socket.emit('writeFile', newpath, '', null, (error) => {
                    if(error) {
                      window.swal('Error', error.message, 'error');
                    }
                  });
                }
              });
            $timeout(() => {
              $('.swal2-input').select();
            }, 0);
            $('.sweet-alert input').select();
            $('.swal2-input').select();
          };

          scope.nodeOnClose = function(node, callback){
            socket.emit('removeWatcher', scope.$id, node.id, function(){
              callback();
            });
          };

          scope.nodeLoad = function(node, callback){
            let promise:any = Promise.resolve();

            if(node.id === '~'){
              promise = promise.then(() => {
                return new Promise<void>((resolve, reject) => {
                  socket.emit('os.homedir', (err, homedir) => {
                    if(err){return reject();}
                    node.id = homedir;
                    node.text = homedir;
                    resolve();
                  });
                });
              });
            }
            promise.then(() => {
              // let url = '/api/containers/' + scope.container._id + '/tree';
              socket.emit('tree', scope.$id, node.id, (error, nodes) => {
                nodes = nodes.map((node) => createNode(node));
                if(!error) {
                  nodes.sort((a, b) => a.id.localeCompare(b.id));
                }
                callback(error, nodes);
              });
            });
          };

          scope.nodeRename = function(node, newName, callback){
            console.log('emitting rename', node.id, newName);
            socket.emit('rename', node.id, newName, function(error){
              if(error) {
                window.swal('Error', error.message, 'error');
              }
              callback(error);
            });
          };

          scope.contextmenu = {
            opened: false,
            top: 0,
            left: 0,
          };
          scope.nodeOnContextmenu = (event, node) => {
            console.log("nodeOnContextMenu", event, node, event.pageX, event.pageY);
            scope.contextmenu.opened = true;
            scope.contextmenu.node = node;
            const bcr = element[0].getBoundingClientRect();
            let pageX, pageY;
            if(event.type === 'touchstart'){
              pageX = event.touches[0].pageX;
              pageY = event.touches[0].pageY;
            }else{
              pageX = event.pageX;
              pageY = event.pageY;
            }
            scope.contextmenu.left = pageX - (bcr.left + window.scrollX);
            scope.contextmenu.top = pageY - (bcr.top + window.scrollY);
          };
          scope.contextmenuDelete = () => {
            const nodes = scope.controller.getSelected();
            const filenames = nodes.map((node) => node.text).join(',');
            window.swal({
              type: 'warning',
              title: $filter('translate')('ARE_YOU_SURE_TO_DELETE_FILES', {files: filenames}),
              text: $filter('translate')('ARE_YOU_SURE_TEXT'),
              showCancelButton: true,
              focusCancel: true,
              confirmButtonText: $filter('translate')('DELETE'),
              cancelButtonText: $filter('translate')('CANCEL'),
              confirmButtonColor: "#D9534E",
            }).then(() => {
              nodes.forEach((node) => {
                /* if (node.children instanceof Array) {
                  return;
                }*/
                socket.emit('unlink', node.id, {recursive: true, force: true}, (error) => {
                  if (error) {
                    window.swal('Error', error.message, 'error');
                  }
                });
              });
            });
          };

          function getResourceUrl(filename, isFolder?:boolean, filetype?){
            let url = scope.container.containerAgentUrl +
              '/api/resource?' +
              'resource=' + encodeURIComponent(filename) +
              '&' +
              'download=true' +
              '&' +
              'access_token=' + scope.container.containerToken +
              '';
            if(isFolder){
              url = url + '&is_folder=true';
              filetype = filetype || 'tar.gz';
            }
            if(filetype){
              url = url + `&filetype=${filetype}`;
            }
            return url;
          }
          /*
          scope.getResourceUrl = (node) => {
            let filename = node.id;
            let url = getResourceUrl(filename, !!node.children);
            return url;
          };
          */
          scope.download = () => {
            let nodes = scope.controller.getSelected();
            const node = nodes[0];
            let filename = node.id;
            let p = Promise.resolve();
            p = p.then(() => {
              let url = getResourceUrl(filename, !!node.children);
              window.open(url);
            });

            /*
            nodes.forEach(function(node){
              if(node.children){
                return;
              }
              let filename = node.id;
              let url = getResourceUrl(filename);
              window.open(url);
            });
            */
          };
          scope.nodeDragstart = (node, $event) => {
            console.log("fileTree: nodeDragstart", $event, node);
            let p = Promise.resolve();
            p = p.then(() => {
              const dataTransfer = $event.originalEvent.dataTransfer;

              // dataTransfer.effectAllowed = 'move';
              // dataTransfer.dropEffect = 'move';
              dataTransfer.effectAllowed = 'copyMove';
              dataTransfer.dropEffect = 'copy';

              // dataTransfer.setData('Text', scope.node.id);
              let filename = node.id;
              let basename = filename.split('/').pop();
              let url = getResourceUrl(filename, !!node.children);
              if(node.children){
                basename = basename + '.tar.gz';
              }
              // dataTransfer.setData('URL', url);
              const downloadUrl = 'application/octet-stream:' + basename + ':' + url;
              // const downloadUrl = url;
              dataTransfer.setData('DownloadURL', downloadUrl);
              // dataTransfer.setData('text/plain', 'fuga');
              console.log('DownloadURL', downloadUrl);
              dataTransfer.setData('filename', filename);
              dataTransfer.setData('text/plain', filename);
            });

          };
          scope.nodeDragover = (node, $event) => {
            const dataTransfer = $event.dataTransfer;
            const itemFilename = Array.from(dataTransfer.items).find((item:any) => item.type === 'filename');
            dataTransfer.dropEffect = 'copy';
            if(itemFilename){
              if(!($event.ctrlKey || $event.altKey)) {
                dataTransfer.dropEffect = 'move';
              }
            }
          };
          scope.reload = () => {
            let nodes = scope.controller.getSelected();
            nodes.forEach((node) => {
              node.scope.reload(() => {});
            });
          };

          scope.nodeDblclick = (event, node) => {
            console.log("nodeDblclick", event, node);

            let filename = node.id;
            scope.container.openFile(scope.windowModels, filename, event);
          };
          scope.open = () => {
            let nodes = scope.controller.getSelected();
            nodes.forEach((node) => {
              let filename = node.id;
              scope.container.openFile(scope.windowModels, filename);
            });
          };
          scope.rename = () => {
            const node = scope.controller.getSelected()[0];
            if(!node){
              return;
            }
            node.scope.edit();
          };
          scope.duplicate = () => {
            let nodes = scope.controller.getSelected();
            if(nodes.length === 0){
              return;
            }
            const node = nodes[0];
            const filename = node.id;
            let basename = filename.split('/').pop();
            const parts = basename.split('.');
            let ext;
            let basepart;
            if(parts.length >= 2){
              ext = '.' + parts.pop();
              basepart = parts.join('.');
            }else{
              ext = '';
              basepart = basename;
            }
            basename = `${basepart}-2${ext}`;

            window.swal({
              title: $filter('translate')('DUPLICATE'),
              text: $filter('translate')('FILENAME') + ':',
              input: 'text',
              inputValue: basename,
            })
              .then((newBasename) => {
                if(newBasename){
                  let newFilename = getSelectedDirectory() + '/' + newBasename;
                  socket.emit('copyFile', filename, newFilename, 1/*fs.constants.COPYFILE_EXCL*/, (error) => {
                    if(error) {
                      console.log('copyFile error:', error);
                      if(error.code === 'EEXIST'){
                        window.swal('Error', $filter('translate')('STRERROR_EEXIST'), 'error');
                      }else{
                        window.swal('Error', error.message, 'error');
                      }
                    }
                  });
                }
              });
            $timeout(() => { $('.swal2-input').select(); });
          };
          scope.openInBrowser = () => {
            const nodes = scope.controller.getSelected();
            nodes.forEach((node) => {
              const filename = node.id;
              const url = `${scope.container.containerAgentUrl}/filesystem${filename}`;

              wmController.openBrowser(null, url);
              /*
              const windowModel = {
                application: 'browser',
                model: {
                  url: url,
                },
              };
              scope.container.addWindowModel(null, windowModel);
              scope.container.activateWindowModel(windowModel);
              */
            });
          };
          scope.canOpenInBrowserPublicHtml = () => {
            let nodes = scope.controller.getSelected();
            let found = nodes.some((node) => {
              let filename = node.id;
              let pos = filename.indexOf('/home/ubuntu/public_html/');
              return pos === 0;
            });
            return found;
          };
          scope.openInBrowserPublicHtml = function(){
            let nodes = scope.controller.getSelected();
            nodes.forEach(function(node){
              let filename = node.id;
              let pos = filename.indexOf('/home/ubuntu/public_html/');
              if(pos !== 0){
                return;
              }
              let urlUserPath = filename.replace(new RegExp("/home/ubuntu/public_html/"), '');
              let url = `https://${scope.container.containerHostname}/~ubuntu/${urlUserPath}`;

              wmController.openBrowser(null, url);
              /*
              let windowModel = {
                application: 'browser',
                model: {
                  url: url,
                },
                ctrl: {},
              };
              scope.container.addWindowModel(windowModel);
              scope.container.activateWindowModel(windowModel);
              */
            });
          };

          scope.findInFolder = () => {
            const node = scope.controller.getSelected()[0];
            window.swal({
              title: $filter('translate')('FIND_IN_FOLDER'),
              text: $filter('translate')('KEYWORD') + ':',
              input: 'text',
              // inputValue: dir,
            })
              .then((keyword) => {
                if(keyword){
                  const command =
                    `test -f /usr/local/bin/fzf || (git clone --depth 1 https://github.com/junegunn/fzf.git /tmp/fzf && /tmp/fzf/install --no-bash && sudo cp /tmp/fzf/bin/fzf /usr/local/bin/fzf)\n` +
                    `cd ${node.id} && fgrep --color=always -rni -m 1000 '${keyword}' . | sed -e 's|[.]/||' | fzf --ansi --layout=reverse -m --sync | awk -F: '{print "${node.id}/" $1}' | xargs -r /usr/local/bin/paizacloud-open-editor && exit\n`;
                  scope.container.ctrl.openTerminal(null, command);
                }
              });
            $timeout(() => { $('.swal2-input').select(); });
          };


          scope.isHidden = (node) => {
            if(scope.showHidden){
              return false;
            }
            if(!node.id || ! node.parent){
              return false;
            }
            let basename = node.id.split('/').pop();
            return basename[0] === '.';
          };

          scope.onUpload = (node, $event) => {
            const target = node.id;
            PCModalFileUploadService.open(scope.container, target, null);
          };
          scope.nodeUploadFiles = (node, $event, files, callback) => {
            const dataTransfer = $event.dataTransfer;
            const srcFilename = dataTransfer.getData("filename");
            let target = node.id;

            if(srcFilename){
              const srcBasename = srcFilename.split('/').pop();
              const targetFilename = target + '/' + srcBasename;

              if($event.ctrlKey || $event.altKey){
                socket.emit('copyFile', srcFilename, targetFilename, 0, function(error){
                  if(error) {
                    window.swal('Error', error.message, 'error');
                  }
                  callback(error);
                });
              }else{
                socket.emit('rename', srcFilename, targetFilename, function(error){
                  if(error) {
                    window.swal('Error', error.message, 'error');
                  }
                  callback(error);
                });
              }
              return;
            }

            if(!files || files.length === 0){
              return;
            }

            return PCModalFileUploadService.open(scope.container, target, files)
              .then((result) => {
                callback(result);
              })
              .catch((error) => {
                callback();
              });
          };

          scope.setShowHidden = (val) => {
            scope.showHidden = val;
          };
        },
        post: function(scope, element, attrs) {
        },
      },
    };
  });
